import Vue from "vue";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import { parsePhoneNumber } from "libphonenumber-js";
import { Widget } from "../components/services/participant-service";

Vue.filter("dobWithMY", value => momentTimeZone(value).format("MM, YYYY"));
Vue.filter("dobWithY", value => momentTimeZone(value).format("YYYY"));
Vue.filter("formatGMTDate", value =>
  momentTimeZone(value)
    .tz("Greenwich")
    .format("MMM DD, YYYY h:mm A z")
);
Vue.filter("formatUTCDate", value =>
  momentTimeZone(value)
    .tz("UTC")
    .format("MMM DD, YYYY hh:mm A z")
);
Vue.filter("newFormatUTCDate", value =>
  momentTimeZone(value)
    .tz("UTC")
    .format("MMM DD, YYYY [at] hh:mm A z")
);

Vue.filter("dateFormat", (value, type) => {
  const formatType = type || "MM/DD/YYYY";
  return moment
    .utc(value)
    .format(formatType)
    .toUpperCase();
});

Vue.filter("queryToolDateFormat", value =>
  momentTimeZone(value)
    .tz("EST")
    .format("MM/DD/YYYY")
);

Vue.filter("phone", phone => {
  const tempPhone = phone.replace(/[^0-9]/g, "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  return tempPhone;
});

Vue.filter("convertToPST", value =>
  momentTimeZone(value)
    .tz("America/Los_Angeles")
    .format("DD MMM YYYY, hh:mm A")
);
Vue.filter("dueDateIndicator", value =>
  momentTimeZone(value)
    .tz("Greenwich")
    .format("DD MMM YYYY")
);
Vue.filter("dob", value => momentTimeZone(value).format("MMMM DD, YYYY"));
Vue.filter("onlyMonth", value => momentTimeZone(value).format("MMM DD"));
Vue.filter("stripTags", value => {
  const tempDivElement = document.createElement("div");
  tempDivElement.innerHTML = value;
  const innerText = tempDivElement.innerText;
  tempDivElement.remove();
  return innerText;
});

Vue.filter("toEST", value =>
  momentTimeZone(value)
    .tz("EST")
    .format("DD MMM YYYY hh:mm A")
);

Vue.filter("dateFUTC", value => momentTimeZone(value).format("MMM DD, YYYY hh:mm A"));

Vue.filter("dateInUTC", value =>
  momentTimeZone(value)
    .tz("UTC")
    .format("DD MMM YYYY, hh:mm A z")
    .toUpperCase()
);

Vue.filter("dateUTC", value => momentTimeZone(value).format("MMM DD, YYYY"));
Vue.filter("formatArchiveDate", value =>
  momentTimeZone(value)
    .tz("UTC")
    .format("DD MMM YYYY hh:mm A z")
);
Vue.filter("Date_FORMAT", value => {
  return moment(value).format("LL"); // Example Feb 25, 2021
});

Vue.filter("customDateFilter", value => {
  const date = moment(value);
  if (moment().diff(date, "days") >= 1) {
    if (date.fromNow() == "a day ago") {
      return "1 day ago";
    }
    return date.fromNow();
  }
  if (date.calendar().split(" ")[0] == "Yesterday") {
    return "1 day ago";
  }
  return date.calendar().split(" ")[0];
});

Vue.filter("customDateHrMinSecCalculate", value => {
  // return moment(new Date(value)).fromNow();
  const seconds = Math.floor((new Date() - new Date(value)) / 1000);
  let interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years ago";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months ago";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days ago";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours ago";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " min ago";
  }
  return Math.floor(seconds) + " sec ago";
});

Vue.filter("translate", function(key, language) {
  const lang = new Widget();
  if (language !== undefined && language !== "" && language !== "en" && language !== "EN") {
    lang.languageCulture = language;
    const tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = lang.i18n(key) !== false ? lang.i18n(key) : tempDivElement.innerHTML;
    const innerText = tempDivElement.innerText;
    tempDivElement.remove();
    return innerText;
  } else {
    return "";
  }
});

Vue.filter("formatGMTDateTime", (value, type) => {
  const formatType = type || "DD MMM YYYY h:mm A z";
  return momentTimeZone(value)
    .tz("Greenwich")
    .format(formatType)
    .toUpperCase();
});
//provide a international phone number with country code to filter it out for the national format
Vue.filter("national", (value = "", countryCodeOld = null, countryIso2Code = null) => {
  let countryCode = countryCodeOld;
  let parsed = value.toString().trim();
  if (parsed.toString().charAt(0) == "+") {
    countryCode = null;
  } else if (countryCode) {
    if (countryCode.toString().charAt(0) != "+") {
      countryCode = "+" + countryCode.toString();
    }
    parsed = countryCode.toString() + parsed;
  } else if (parsed.toString().length == 10 || parsed.toString().length == 11) {
    countryCode = "+1";
  }
  try {
    parsed = countryIso2Code && countryIso2Code.toString().trim().length > 0 ? parsePhoneNumber(parsed, countryIso2Code).formatNational() : parsePhoneNumber(parsed).formatNational();
  } catch (e) {
    parsed = value.toString().trim();
  }
  return parsed;
});
Vue.filter("e164", (value = "", countryCodeOld = null, countryIso2Code = null) => {
  let countryCode = countryCodeOld;
  let parsed = value.toString().trim();
  if (parsed.toString().charAt(0) == "+") {
    countryCode = null;
  } else if (countryCode) {
    if (countryCode.toString().charAt(0) != "+") {
      countryCode = "+" + countryCode.toString();
    }
    parsed = countryCode.toString() + parsed;
  } else if (parsed.toString().length == 10 || parsed.toString().length == 11) {
    countryCode = "+1";
  }
  try {
    parsed = countryIso2Code && countryIso2Code.toString().trim().length > 0 ? parsePhoneNumber(parsed, countryIso2Code).number : parsePhoneNumber(parsed).number;
  } catch (e) {
    parsed = value.toString().trim();
  }
  return parsed;
});
Vue.filter("trim0", (value = "") => {
  if (
    value
      .toString()
      .trim()
      .charAt(0) == "0"
  ) {
    return value
      .toString()
      .trim()
      .substring(1);
  }
  return value;
});
Vue.filter("CapitalizeFirstLetters", str => {
  const values = str && str.trim() && str.split(" ");
  let updatedStr = "";
  if (!values) {
    return updatedStr;
  }
  for (let i = 0; i < values.length; i++) {
    if (values[i]) {
      updatedStr += values[i].charAt(0).toUpperCase() + values[i].substring(1).toLowerCase() + " ";
    }
  }
  updatedStr = updatedStr.trim();
  return updatedStr;
});
